let detector

class CustomLocalStorage {
  static _store = {}
  static _native = window.localStorage
  static _initialized = false
  static _detector = null

  static init() {
    if (this._initialized) return
    this._initialized = true

    this._loadFromNative()
    this._replaceLocalStorage()
    this._initIdleListener()
  }

  static _loadFromNative() {
    Object.keys(this._native).forEach(key => {
      this._store[key] = this._native.getItem(key)
    })
  }

  static _saveToNative() {
    this._native.clear()
    Object.keys(this._store).forEach(key => {
      const value = this._store[key]
      this._native.setItem(key, value)
    })
  }

  static _replaceLocalStorage() {
    Object.defineProperty(window, 'localStorage', {
      value: this,
      writable: false,
      configurable: false,
      enumerable: true,
    })
  }

  static _initIdleListener() {
    if (detector) return
    loadActivityDetector(() => {
      if (typeof activityDetector !== 'undefined') {
        detector = activityDetector({
          timeToIdle: 5000,
        })

        detector.on('idle', () => {
          // console.log(
          //   '[CustomLocalStorage] User idle — syncing memory to localStorage',
          // )
          CustomLocalStorage._saveToNative()
        })

        detector.on('active', () => {
          // console.log(
          //   '[CustomLocalStorage] User active — syncing memory to localStorage',
          // )
          CustomLocalStorage._saveToNative()
          // Events.dispatch('device_active')
        })
      }
    })
  }

  // API compatible avec localStorage
  static getItem(key) {
    const val = this._store[key]
    return val
  }

  static setItem(key, value) {
    this._store[key] = `${value}`
  }

  static removeItem(key) {
    delete this._store[key]
  }

  static clear() {
    this._store = {}
  }

  static key(index) {
    return Object.keys(this._store)[index] || null
  }

  static get length() {
    return Object.keys(this._store).length
  }
}

function loadActivityDetector(callback) {
  const script = document.createElement('script')
  script.src =
    'https://unpkg.com/activity-detector/dist/activity-detector.min.js'
  script.onload = () => {
    if (typeof callback === 'function') {
      callback()
    }
  }
  document.head.appendChild(script)
}

// Activer la logique au démarrage
// CustomLocalStorage.init();

export default CustomLocalStorage
